import React from 'react';
import noop from 'lodash/noop';
import Dialog from 'pages/Dashboard/components/Dialog';
import ClaimActivityLogs from 'pages/Dashboard/pages/Billing/ClaimForm/ClaimActivity/ClaimActivityLogs';

export type ClaimActivityDialogParams = {
  claimId: number;
};

type Props = ClaimActivityDialogParams & {
  onClose: () => void;
};

export default function ClaimActivityDialog({
  claimId,
  onClose,
}: Props) {
  return (
    <Dialog
      open
      title="Claim Activity"
      onClose={onClose}
      onConfirm={noop}
      dialogClassName="rounded-lg"
      maxWidth="md"
      className="!w-176 overflow-hidden !p-0 !space-y-0 max-h-[calc(100vh-100px)]"
      titleClassName="px-6 py-4"
    >
      <div className="flex flex-col flex-1 overflow-auto px-6 pb-4">
        <ClaimActivityLogs claimId={claimId} />
      </div>
    </Dialog>
  );
}
